module.exports = __webpack_public_path__ + "static/media/algocuts.86aecd7b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/algocuts.gif
// module id = 258
// module chunks = 0